<script setup lang="ts">
/**
 * Entry page for the flow
 * --------------------------------------------------------------------------------------------------
 * This page is SERVER-SIDE-RENDERED and serves as a fast-loaded entry point
 * to the product flow. it resets all stores.
 */
definePageMeta({
    layout: 'empty',
    path: '/booking/joch-epr/start',
    title: 'offerFlow.splashMessage.joch-epr',
});

onMounted(() => {
    useResetStores().resetOfferFlow();
    useStartFreshFlow().startFreshFlow(productConfigJochEPR);
});
</script>

<template>
    <IntroLoader />
</template>
